
import state from './state';
import Store from '../base';


export default class Categories extends Store {
    constructor(model, ng){

        state.model = model;

        super({state, ng});
    }
}


// WEBPACK FOOTER //
// ./src/app/store/categories/index.js